export const formatMoney = (value: number, currency?: string): string => {
  const parts = value.toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${parts.join(',')}${currency ? ` ${currency}` : ''}`;
};
